
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"></path><g opacity=".5" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 16c-1.115 0-2.232.302-3.292.908-1.063.607-2.051 1.51-2.898 2.679l-1.62-1.174c.992-1.368 2.186-2.476 3.525-3.242C9.058 14.404 10.515 14 12 14c1.485 0 2.942.404 4.285 1.171 1.34.766 2.533 1.874 3.525 3.242l-1.62 1.174c-.847-1.168-1.835-2.072-2.898-2.68C14.232 16.303 13.115 16 12 16z"></path><path d="M12 8a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0z"></path></g>
    </svg>
  </template>
  <script>
    export default {
      name: "IconMy",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
